<template>
  <el-dialog
    top="8vh"
    width="1000px"
    append-to-body
    :visible="dialogVisible"
    @close="handleClose"
    @open="handleOpen"
  >
    <div class="cdk-dialog" v-loading="formLoading">
      <div class="cdk-dialog__title">使用您的CDKEY</div>
      <el-radio-group class="cdk-dialog__tab" v-model="tabPosition">
        <el-radio-button :label="1">授权</el-radio-button>
        <el-radio-button :label="2">订购</el-radio-button>
      </el-radio-group>
      <div class="cdk-dialog__tip">{{ tipText }}</div>
      <div class="cdk-dialog__form">
        <div v-show="tabPosition === 1" class="cdk-dialog__form-selcdk">
          <div class="cdk-dialog__form-selcdk-title">CDKEY：</div>
          <el-select
            style="width: 100%;"
            v-model="cdkeyId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in cdkeyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-form
          class="cdk-dialog__form-warp"
          v-show="tabPosition === 2"
          label-width="100px"
          label-position="top"
          :model="vipForm"
          :rules="vipsRuler"
          ref="vipsref"
        >
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="姓名:" prop="name">
                <el-input v-model="vipForm.name" placeholder="请输入您的姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司:" prop="companyName">
                <el-input
                  v-model="vipForm.companyName"
                  placeholder="请输入您的公司名称"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="电话:" prop="phone">
                <el-input
                  v-model="vipForm.phone"
                  placeholder="请输入您的电话号码"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商务邮箱:" prop="email">
                <el-input
                  v-model="vipForm.email"
                  placeholder="请输入您的是商务邮箱"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="头衔:" prop="title">
                <el-input
                  v-model="vipForm.title"
                  placeholder="请输入您的职位"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="雇员人数:" prop="employees">
                <el-input
                  v-model="vipForm.employees"
                  placeholder="请输入您的公司实际在职人数"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="cdk-dialog__form-check">
            <el-checkbox
              v-model="vipForm.agree"
              class="checkBoxContainer_check"
            >
              我同意
              <span class="color-blue" @click.prevent="$emit('view-tems', '1')">
                《好账先生服务条款》
              </span>
              <span class="color-blue" @click.prevent="$emit('view-tems', '2')">
                《好账先生隐私条款》
              </span>
            </el-checkbox>
            <span :class="{ 'color-primary': vipForm.agree }"
              >并与Mankoo分享此信息，官方客服可能会使用它来进行有关的演示，优惠和更新的信息。</span
            >
          </div>
        </el-form>
      </div>
      <div class="cdk-dialog__footer">
        <el-button v-show="tabPosition === 1" @click="handleClose"
          >取消</el-button
        >
        <el-button v-show="tabPosition === 1" type="primary" @click="hzUseCdkey"
          >使用</el-button
        >
        <el-button
          v-show="tabPosition === 2"
          type="warning"
          @click="getVipsPrice"
          >获取报价</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CDKSelect",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    loginName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tabPosition: 1,
      cdkeyId: "",
      cdkeyList: [],

      formLoading: false,
      vipForm: {
        name: "",
        companyName: "",
        phone: "",
        email: "",
        title: "",
        employees: "",
        agree: ""
      },
      vipsRuler: {
        name: [{ required: true, message: "请你填写您的名字" }],
        companyName: [{ required: true, message: "请您填写您的公司名字" }],
        phone: [{ required: true, message: "请您填写您的电话号码" }],
        email: [{ required: true, message: "请您填写您的商务邮箱" }],
        title: [{ required: true, message: "请您填写您的职位" }],
        employees: [{ required: true, validator: this.isexChangerate }]
      }
    };
  },
  computed: {
    tipText() {
      const obj = {
        1: "如果您已成功购买了系统，请在下方选择要使用的密匙",
        2: "好账先生提供系统、高级财税服务，请提交您的信息"
      };
      return obj[this.tabPosition];
    }
  },
  created() {
    this.getCdkeyList();
  },
  methods: {
    // 获取cdk列表
    getCdkeyList() {
      const data = {
        loginName: this.loginName
      };
      this.$http.post("cdkeyContrller/getCdkeyList", data).then(res => {
        if (res.data.code === "1") {
          const data = res.data.data;
          if (data && data.length) {
            this.cdkeyList = data.map(item => {
            return {
              value: item.id,
              label: `CDKEY [${item.cdKey}] - 时长 ${item.extent} 个月`
            };
          });
          this.cdkeyId = this.cdkeyList[0].value;
          }
        }
      });
    },
    // 使用cdk
    hzUseCdkey() {
      if (!this.cdkeyId) return this.$message.error("请先选择将要授权的CDKEY");
      const data = {
        cdkeyId: this.cdkeyId,
        loginName: this.loginName
      };
      this.formLoading = true;
      this.$http
        .post("cdkeyContrller/hzUseCdkey", data)
        .then(res => {
          this.formLoading = false;
          if (res.data.code === "1") {
            this.$emit("hzUseCdkey", res);
          }
        })
        .catch(() => (this.formLoading = false));
    },
    // 获取报价
    getVipsPrice(ref) {
      if (!this.vipForm.agree) {
        return this.$message.warning("请您阅读Mankoo相关服务和隐私条款并同意!");
      }
      this.$refs[ref].validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.$http
            .post("account/experience/save", this.vipForm)
            .then(res => {
              this.formLoading = false;
              if (res && res.data.code == 1) {
                this.$alert(
                  "我们客服已收到您的申请请求，稍后会有专业客服联系您！",
                  "温馨提示",
                  {
                    confirmButtonText: "确定",
                    showClose: false,
                    callback: () => {
                      this.$emit("update:dialogVisible", false);
                    }
                  }
                );
              }
            })
            .catch(() => {
              this.formLoading = false;
            });
        }
      });
    },
    // 人数验证
    isexChangerate(rule, value, callback) {
      if (!value) {
        return callback(new Error("雇员人数不能为空！"));
      }
      setTimeout(() => {
        if (!Number(value)) {
          return callback(new Error("雇员人数只能是数字！"));
        } else {
          return callback();
        }
      });
    },
    handleOpen() {
      this.tabPosition = 1;
      this.getCdkeyList();
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
      this.vipForm = this.$options.data().vipForm;
      this.$refs.vipsref.resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.cdk-dialog {
  text-align: center;
  &__title {
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  &__tab {
    margin: 30px 0;
    /deep/.el-radio-button {
      &__inner {
        width: 108px;
        padding-top: 6px;
        padding-bottom: 6px;
        &:hover {
          color: #269d7b;
        }
      }
      &__orig-radio {
        &:checked + .el-radio-button__inner {
          color: #fff;
          background-color: #269d7b;
          border-color: #269d7b;
        }
      }
    }
  }
  &__tip {
    font-size: 12px;
    color: #666666;
    line-height: 17px;
  }
  &__form {
    position: relative;
    min-height: 380px;
    text-align: left;
    box-sizing: border-box;
    overflow: hidden;
    &-selcdk {
      position: absolute;
      top: 35%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 600px;
      &-title {
        margin-bottom: 12px;
        text-align: left;
        color: #666666;
        line-height: 20px;
      }
    }
    &-warp {
      width: 700px;
      margin: 30px auto 0;
      .el-form-item {
        margin-bottom: 16px !important;
      }
    }
  }
  &__footer {
    text-align: center;
    margin-bottom: 30px;
    .el-button {
      width: 150px;
      height: 50px;
      &:first-child {
        &:focus,
        &:hover {
          color: #3dcfa6;
          border-color: #c6f3e6;
          background-color: #e0f5ef;
        }
      }
      &--primary {
        background: #20bd90;
        border-color: #20bd90;
      }
    }
  }
  .color-blue {
    color: #268aff;
  }
  .color-primary {
    color: #269d7b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/CDKSelect.vue